<h2 mat-dialog-title>DPP Details</h2>

<mat-dialog-content>
  <div class="pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section">

      <div class="my-4 section-title">
        <mat-icon class="custom-card-icon material-symbols-outlined">info</mat-icon>{{'tridys.tridy_info' | translate}}
      </div>

      <mat-card class="mb-2">
        <mat-card-content class="my-2">

          <div class="font-weight-bold">
            ID: <span style="opacity:0.65;padding-right: 5px;">{{data.idToShow}}</span>
            <mat-icon matTooltip="{{'copyToClipboard' | translate}}" [cdkCopyToClipboard]="data.idToShow" class="copy_id">content_copy</mat-icon>
          </div>

          <div class="d-flex flex-column text-muted">
            @if (tridyData && tridyData.creationDate) {
              <span>
                {{'creation_date' | translate}}: {{tridyData.creationDate.toDate() | date: 'dd.MM.yyyy, HH:mm'}}
              </span>
            }
            @if (tridyData && tridyData.timeStamp) {
              <span>
                {{'last_update' | translate}}: {{tridyData.timeStamp.toDate() | date: 'dd.MM.yyyy, HH:mm'}}
              </span>
            }
          </div>

        </mat-card-content>
      </mat-card>

      @if (finishedTasks.length!=0) {
        <div >
          <div class="my-4 section-title">
            <mat-icon class="custom-card-icon material-symbols-outlined">task</mat-icon>{{'tridys.finished' | translate}}
          </div>
          <mat-card class="mb-2">
            <mat-card-content class="my-2">
              @for (ftask of finishedTasks; track ftask) {
                <div class="item-content my-1" routerLink="finishedTasks/{{ftask.id}}">
                  <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                    <div class="d-flex flex-column flex-nowrap">
                      <span style="color:var(--warmOrange);">{{ftask.title}}</span>
                      <div>
                        <span class="text-muted">{{ftask.creationDate.toDate() | date:'dd.MM.yyyy, HH:mm' }}</span>
                        @if (ftask.timeStamp) {
                          <span class="text-muted">  - {{ftask.timeStamp.toDate() | date:'dd.MM.yyyy, HH:mm' }}</span>
                        }
                      </div>
                    </div>
                    <span class="material-symbols-outlined" style="color:var(--warmOrange);">
                      keyboard_arrow_right
                    </span>
                  </div>
                </div>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }

      @if (incoming && incoming.length!=0) {
        <div>
          <div class="my-4 section-title">
            <mat-icon class="custom-card-icon material-symbols-outlined">input</mat-icon>{{'workTask.incoming_tridys' | translate}}
          </div>
          <mat-card class="mb-2">
            <mat-card-content class="my-2">
              @for (incom of incoming; track incom; let last = $last; let index = $index) {
                <div class="item-content my-1">
                  <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                    <div class="d-flex flex-column flex-nowrap">
                      @if (getContentTypeFieldbyId(incom.contentTypeId, 'titleKey')) {
                        <div class="title-key-2">
                          {{getTitleKeyOfTridy(getTRIDYIdData(incom.tridyId, 'payload'), getContentTypeFieldbyId(incom.contentTypeId, 'titleKey'))}}
                        </div>
                      }
                      @if (getContentTypeFieldbyId(incom.contentTypeId, 'subtitleKeys')) {
                        <div>
                          @for (subtitle of getSubtitleKeyOfTridy(getTRIDYIdData(incom.tridyId, 'payload'), getContentTypeFieldbyId(incom.contentTypeId, 'subtitleKeys')); track subtitle) {
                            <div>
                              @if (subtitle?.contentType === 'public.image') {
                                <div class="subtitle-key-2">{{subtitle.fileName}}</div>
                              }
                              @if (subtitle?.contentType !== 'public.image') {
                                <div class="subtitle-key-2">{{subtitle}}</div>
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (!getContentTypeFieldbyId(incom.contentTypeId, 'titleKey') && !getContentTypeFieldbyId(incom.contentTypeId, 'subtitleKeys')) {
                        <span class="title-key-2">
                          {{getContentTypeFieldbyId(incom.contentTypeId, 'displayName')}}
                        </span>
                      }
                      <div class="mt-1">ID: {{incom.tridyId}}</div>
                      <div class="d-flex flex-column text-muted">
                        @if (getTRIDYIdData(incom.tridyId, 'creationDate')) {
                          <span>
                            {{'creation_date' | translate}}: {{getTRIDYIdData(incom.tridyId, 'creationDate').toDate() | date:'dd.MM.yyyy, HH:mm' }}
                          </span>
                        }
                        @if (getTRIDYIdData(incom.tridyId, 'timeStamp')) {
                          <span>
                            {{'last_update' | translate}}: {{getTRIDYIdData(incom.tridyId, 'timeStamp').toDate() | date:'dd.MM.yyyy, HH:mm' }}
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                  @if (!last) {
                    <hr>
                    }
                  </div>
                }
              </mat-card-content>
            </mat-card>
          </div>
        }

        @if (outgoing && outgoing.length!=0) {
          <div>
            <div class="my-4 section-title">
              <mat-icon class="custom-card-icon material-symbols-outlined">output</mat-icon>{{'workTask.outgoing_tridys' | translate}}
            </div>
            <mat-card class="mb-2">
              <mat-card-content class="my-2">
                @for (out of outgoing; track out; let last = $last; let index = $index) {
                  <div class="item-content my-1">
                    <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
                      <div class="d-flex flex-column flex-nowrap">
                        @if (getTRIDYIdData(out.tridyId, 'payload')) {
                          <div>
                            @if (getContentTypeFieldbyId(out.contentTypeId, 'titleKey')) {
                              <div class="title-key-2">
                                {{getTitleKeyOfTridy(getTRIDYIdData(out.tridyId, 'payload'), getContentTypeFieldbyId(out.contentTypeId, 'titleKey'))}}
                              </div>
                            }
                            @if (getContentTypeFieldbyId(out.contentTypeId, 'subtitleKeys')) {
                              <div>
                                @for (subtitle of getSubtitleKeyOfTridy(getTRIDYIdData(out.tridyId, 'payload'), getContentTypeFieldbyId(out.contentTypeId, 'subtitleKeys')); track subtitle) {
                                  <div>
                                    @if (subtitle?.contentType === 'public.image') {
                                      <div class="subtitle-key-2">{{subtitle.fileName}}</div>
                                    }
                                    @if (subtitle?.contentType !== 'public.image') {
                                      <div class="subtitle-key-2">{{subtitle}}</div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                            @if (!getContentTypeFieldbyId(out.contentTypeId, 'titleKey') && !getContentTypeFieldbyId(out.contentTypeId, 'subtitleKeys')) {
                              <span class="title-key-2">
                                {{getContentTypeFieldbyId(out.contentTypeId, 'displayName')}}
                              </span>
                            }
                          </div>
                        }
                        @if (!getTRIDYIdData(out.tridyId, 'payload')) {
                          <div>
                            <span class="title-key-2">
                              {{getContentTypeFieldbyId(out.contentTypeId, 'displayName')}}
                            </span>
                          </div>
                        }
                        <div class="mt-1">ID: {{out.tridyId}}</div>
                        <div class="d-flex flex-column text-muted">
                          @if (getTRIDYIdData(out.tridyId, 'creationDate')) {
                            <span>
                              {{'creation_date' | translate}}: {{getTRIDYIdData(out.tridyId, 'creationDate').toDate() | date:'dd.MM.yyyy, HH:mm' }}
                            </span>
                          }
                          @if (getTRIDYIdData(out.tridyId, 'timeStamp')) {
                            <span>
                              {{'last_update' | translate}}: {{getTRIDYIdData(out.tridyId, 'timeStamp').toDate() | date:'dd.MM.yyyy, HH:mm' }}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                    @if (!last) {
                      <hr>
                      }
                    </div>
                  }
                </mat-card-content>
              </mat-card>
            </div>
          }

          <div class="my-4 section-title">
            <mat-icon class="custom-card-icon material-symbols-outlined">description</mat-icon>{{'tridys.payloadData' | translate}}
          </div>
          <mat-card class="mb-4">
            <mat-card-content class="p-3">
              @if (allpayload.length==0) {
                <div class="p-3">
                  <span class="text-muted">{{'tridys.no_payload_data' | translate}}</span>
                </div>
              }
              @for (payload of allpayload; track payload; let last = $last) {
                <div>
                  @if (!isObject(payload[1])) {
                    <div class="d-flex justify-content-between">
                      <!-- <div class="input-group mt-1 mb-1 w-100" *ngIf="payload[0]!='name' && payload[0]!='description' && payload[0]!='tagline' && payload[0]!='array' && payload[0]!='map'"> -->
                      <div class="py-2 px-4 key-styles"><span class="font-weight-bold">{{payload[0]}}</span></div>
                      <div class="py-2 px-4 value-styles">
                        @if (!payload[1].nanoseconds && !payload[1].seconds && !matchingDate(payload[1])) {
                          <span>{{payload[1]}}</span>
                        }
                        @if (!payload[1].nanoseconds && !payload[1].seconds && matchingDate(payload[1])) {
                          <span>{{payload[1] | date: 'dd.MM.yyyy, HH:mm'}}</span>
                        }
                        @if (payload[1].nanoseconds || payload[1].seconds) {
                          <span>{{payload[1].toDate() | date: 'dd.MM.yyyy, HH:mm' }}</span>
                        }
                      </div>
                    </div>
                  }
                  @if (isObject(payload[1]) && payload[1].contentType) {
                    <div class="d-flex justify-content-between">
                      <div class="py-2 px-4 key-styles">
                        <span class="font-weight-bold">{{payload[0]}}</span>
                        <span class="material-symbols-outlined text-muted" style="vertical-align: middle;font-size: 20px;">attach_file</span>
                      </div>
                      <div class="py-2 px-4 value-styles">
                        @if (payload[1]?.fileName && mediaData && media) {
                          <div>
                            @if (payload[1]?.fileName) {
                              <a href="{{urlData[payload[0]]}}" class="pdf-title" target="_blank">
                                <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>{{payload[1].fileName}}
                              </a>
                            }
                          </div>
                        }
                        @if (!payload[1]?.fileName && mediaData && media && media[payload[0]]) {
                          <div>
                            @if (urlData[payload[0]]) {
                              <a href="{{urlData[payload[0]]}}" target="_blank" style="cursor:zoom-in;">
                                <img src="{{urlData[payload[0]]}}" style="width: 100%; max-height: 250px;">
                              </a>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (isObject(payload[1]) && !payload[1].contentType) {
                    <div class="d-flex justify-content-between">
                      <div class="py-2 px-4 key-styles"><span class="font-weight-bold">{{payload[0]}} TEST</span></div>
                      @if (!payload[1]) {
                        <span class="py-2 px-4 value-styles"> - </span>
                      }
                      @if (payload[1] && !payload[1].nanoseconds && !payload[1].seconds) {
                        <span class="py-2 px-4 value-styles"> * </span>
                      }
                      @if (payload[1] && payload[1].nanoseconds || payload[1].seconds) {
                        <span class="py-2 px-4 value-styles"> {{payload[1].toDate() | date: 'dd.MM.yyyy, HH:mm' }} </span>
                      }
                    </div>
                  }
                  @if (!last) {
                    <mat-divider></mat-divider>
                  }
                </div>
              }
            </mat-card-content>
          </mat-card>

          <div class="mb-4">
            @if (tridyArray) {
              <mat-accordion class="w-100 mt-4">
                <mat-expansion-panel (opened)="panelOpenState = true"
                  (closed)="panelOpenState = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{'tridys.array' | translate}}
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  @for (array of tridyArray; track array) {
                    <p>{{array}}</p>
                  }
                </mat-expansion-panel>
              </mat-accordion>
            }

            @if (tridyMap) {
              <mat-accordion class="w-100 mt-2">
                <mat-expansion-panel (opened)="panelOpenState = true"
                  (closed)="panelOpenState = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{'tridys.map' | translate}}
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  @for (map of tridyMap | keyvalue; track map) {
                    <p> {{map.key}} : {{map.value}}</p>
                  }
                </mat-expansion-panel>
              </mat-accordion>
            }
          </div>

        </section>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button style="color:var(--warmOrange);" (click)="dialogCancel();"> {{'Close' | translate}} </button>
    </mat-dialog-actions>
